import { useState } from 'react';
// @mui
import { alpha } from '@mui/material/styles';
import { Box, Divider, Typography, Stack, MenuItem, Avatar, IconButton, Popover } from '@mui/material';
// mocks_
import account from '../../../utils/account';
import api from '../../../api';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import usePwaInstall from '../../../hooks/usePwaInstall';


// ----------------------------------------------------------------------

const MENU_OPTIONS = [
  {
    label: 'Home',
    icon: 'eva:home-fill',
    path: '/dashboard-admin',
  },
  {
    label: 'Update Profile',
    icon: 'eva:person-fill',
    path: '/update-profile',
  },
  {
    label: 'Settings',
    icon: 'eva:settings-2-fill',
  },
];

// ----------------------------------------------------------------------

export default function AccountPopover() {
  const [open, setOpen] = useState(null);
  const email=JSON.parse(localStorage.getItem('user'))
  const navigate = useNavigate();
  const {
    hasInstallPrompt,
    isStandalone,
    isIos,
    install,
    openIosHint,
  } = usePwaInstall();

  // Permanent install entry: Chrome gets a real prompt; iOS opens the Share instructions.
  const showInstallMenuItem = !isStandalone && (hasInstallPrompt || isIos);

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  const onClickLogout = () => {
    setOpen(null);
    api
    .delete('/sessions',{
    
    })
    .then((response) => {
      if (response) {
    
        localStorage.clear();                                                                                                              
        navigate("/login");
        toast.success("logout successfull");
      }
     
      else {
        toast.error(response.error);                                 
      }
    })
    .catch(() => {
      toast.error('Something went wrong!');
    });
    navigate("/login");
  };

  const onClickMenuOption = (option) => {
    handleClose();
    if (option.path) {
      navigate(option.path);
    }
  };

  const onClickInstall = async () => {
    handleClose();

    if (hasInstallPrompt) {
      const result = await install();
      if (result === 'accepted') {
        toast.success('City Courier installed');
      } else if (result === 'unavailable') {
        toast.info('Install is not available right now. Try Chrome’s menu → Install app.');
      }
      return;
    }

    if (isIos) {
      openIosHint();
    }
  };


  return (
    <>
      <IconButton
        onClick={handleOpen}
        sx={{
          p: 0,
          ...(open && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
            },
          }),
        }}
      >
        <Avatar src={account.photoURL} alt="photoURL" />
      </IconButton>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 0,
            mt: 1.5,
            ml: 0.75,
            width: 200,
            '& .MuiMenuItem-root': {
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle2" noWrap>
            {account.displayName}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {account.email}
          </Typography>
        </Box>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <Stack sx={{ p: 1 }}>
          {MENU_OPTIONS.map((option) => (
            <MenuItem key={option.label} onClick={() => onClickMenuOption(option)}>
              {option.label}
            </MenuItem>
          ))}
          {showInstallMenuItem && (
            <MenuItem onClick={onClickInstall}>
              {isIos && !hasInstallPrompt ? 'Add to Home Screen' : 'Install app'}
            </MenuItem>
          )}
        </Stack>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <MenuItem onClick={onClickLogout} sx={{ m: 1 }}>
          Logout
        </MenuItem>
      </Popover>
    </>
  );
}
